import React from 'react'
import axios from 'shared/lib/axios'
import { flashSuccessMessage, flashErrorMessage } from 'redux-flash'

export const ORDER_DETAIL_FETCH = 'ORDER_DETAIL_FETCH'
export const ORDER_DETAIL_RESPONSE = 'ORDER_DETAIL_RESPONSE'
export const ORDER_DETAIL_CANCEL = 'ORDER_DETAIL_CANCEL'

export function orderDetailResponse(json) {
  return { type: ORDER_DETAIL_RESPONSE, order: json.data }
}

export function orderDetailFetch(id) {
  return (dispatch) => {
    dispatch({ type: ORDER_DETAIL_FETCH })
    return axios
      .get(`/api/order/${id}`)
      .then((json) => dispatch(orderDetailResponse(json)))
  }
}

export function orderDetailCancel(id, options = {}) {
  return async (dispatch) => {
    dispatch({ type: ORDER_DETAIL_CANCEL })

    try {
      await axios.post(`/api/internal_order_cancelled/${id}`, options)

      dispatch(orderDetailFetch(id))
      dispatch(flashSuccessMessage('Order has been cancelled.'))

      return { success: true }
    } catch (e) {
      const data = e?.response?.data
      let errorMessage = data?.message || 'Order cancellation failed'

      if (data?.force_cancellation_allowed) {
        errorMessage = [
          errorMessage,
          <br key="br" />,
          'If you would like to force this cancellation, click Cancel Order again and select the Force Cancel option.',
        ]
      }

      dispatch(flashErrorMessage(errorMessage))

      return {
        success: false,
        forceCancellationAllowed: data?.force_cancellation_allowed,
      }
    }
  }
}
